import { render, staticRenderFns } from "./HistoricOld.vue?vue&type=template&id=c3dcf776"
import script from "./HistoricOld.vue?vue&type=script&lang=js"
export * from "./HistoricOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports